export default __webpack_public_path__ + "static/media/Group_7468.88cdfaeb.png";